/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
import request from '@/shared/utils/request';
import platform from '@/shared/utils/platform';
import URLUtils from '@/shared/utils/URLUtils';
import {
  FINANCE_WX_MINI_PROGRAM, getWebviewAccessDomain, NotifyCommandEnum, WX_JS_SDK_URL,
} from './config';

/** 小程序 appId 缓存 key */
const MINI_PROGRAM_APPID_SESSION_KEY = 'FINANCE_H5_MINI_PROGRAM_APPID_SESSION_KEY';
/** 宿主小程序 appId */
let currentMiniProgramAppId: string | null;

// 获取臻有钱-微信小程序 签名(本地调试，也必须使用https)
export const getWechatSDKSign = (): Promise<{
    // 生成签名的时间戳
    timestamp: string;
    // 生成签名的随机串
    nonceStr: string;
    // 签名
    signature: string;
  }> => request.postGate(
  'wechat.sa.sign',
  {
    systemCode: FINANCE_WX_MINI_PROGRAM.systemCode,
    bizCode: FINANCE_WX_MINI_PROGRAM.bizCode,
    url: window.location.href.split('#')[0],
  },
  {
    baseURL: 'https://api.hellobike.com/api',
    showLoading: undefined,
  },
);

let loadPromise: Promise<void>;

/** 加载微信sdk（不含wx.config配置） */
const loadJsSDKScript = () => {
  // 非微信/非微信小程序环境（如哈啰 App）不加载脚本，避免 load weixin jssdk failed 的 UnhandledRejection
  if (!platform.isWeixin && !platform.isWechatMini) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = new Promise((resolve, reject) => {
    const { wx } = window as any;

    if (wx) {
      resolve(wx);
    } else {
      const script = document.createElement('script');

      script.src = WX_JS_SDK_URL;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('load weixin jssdk failed'));

      document.body.appendChild(script);
    }
  });

  return loadPromise;
};

let configPromise: Promise<void>;
function configWechat(customConfig:
  {
    jsApiList?: string[];
    openTagList?: string[];
    force?: boolean;
    appId?: string;
  }) {
  const {
    jsApiList = [], openTagList = [], force = false, appId = FINANCE_WX_MINI_PROGRAM.appId,
  } = customConfig;

  if (!platform.isWeixin && !platform.isWechatMini) {
    return Promise.reject(new Error('not weixin'));
  }
  if (configPromise && !force) {
    return configPromise;
  }

  configPromise = loadJsSDKScript()
    .then(() => new Promise(async (resolve, reject) => {
      try {
        const { timestamp, nonceStr, signature } = await getWechatSDKSign();
        const { wx } = window as any;
        wx.config({
          debug: false,
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: [
            ...jsApiList,
            'closeWindow',
            'chooseImage',
            'invokeMiniProgramAPI',
          ],
          openTagList: [
            ...openTagList,
          ],
        });

        wx.ready(() => {
          resolve(wx);
        });

        wx.error((res: { errMsg: string; }) => {
          reject(new Error(res.errMsg));
        });
      } catch (err) {
        reject(err);
      }
    }));

  return configPromise;
}

/** 绑定需要注册完成可调用的小程序方法
 * https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html
 * 参考文档：相关接口-2：chooseImage、previewImage、startRecord...
 */
function bindWXMethod(methodName: string) {
  return (...args: unknown[]) => configWechat({})
    .then(() => {
      const { wx } = window as any;

      try {
        return (wx)[methodName](...args) as unknown;
      } catch (err) {
        return new Error(`call wx error: ${(err as Error).message}`);
      }
    });
}

/**
 * 绑定可以直接调用的微信小程序方法
 * https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html
 * 参考文档：相关接口-1：navigateTo、navigateBack、redirectTo....
 */
function bindDirectCallMethod(methodName: string) {
  return (...args: unknown[]) => loadJsSDKScript().then(() => {
    if (!platform.isWeixin && !platform.isWechatMini) {
      return undefined;
    }
    const { wx } = window as any;

    try {
      return wx.miniProgram[methodName](...args) as unknown;
    } catch (err) {
      return new Error(`call wx.miniProgram error: ${(err as Error).message}`);
    }
  });
}

const wechat = {
  appId: FINANCE_WX_MINI_PROGRAM.appId,

  /** 第一类api初始化方法，仅加载微信sdk */
  loadJsSDKScript() {
    return loadJsSDKScript();
  },

  /** 第二类api初始化方法，TODO: 因公众号未申请下来，暂未实现 */
  initRegisterWechatSdk(p = {}) {
    return configWechat(p);
  },
  /** 第二类api，前置条件：1. 加载sdk; 2. 初始化wx.config */
  chooseImage: bindWXMethod('chooseImage'),
  closeWindow: bindWXMethod('closeWindow'),

  /** 第一类api，前置条件：1. 加载sdk; */
  navigateBack: bindDirectCallMethod('navigateBack'),
  navigateTo: bindDirectCallMethod('navigateTo'),
  redirectTo: bindDirectCallMethod('redirectTo'),
  reLaunch: bindDirectCallMethod('reLaunch'),
  postMessage: bindDirectCallMethod('postMessage'),

  backToHome: () => wechat.reLaunch({
    url: '/pages/home/index',
  }),
  redirectToLogin: () => wechat.redirectTo({
    url: '/pages/unionid-login/index',
  }),
  notifyLogout: () => wechat.postMessage({ data: { command: NotifyCommandEnum.LOGOUT } }),
};

/**
 * 检查当前url是否在微信webview无法访问
 * true,无法访问；false,可以访问
 */
export const checkLinkIsNotAccessDomain = async (url: string) => {
  const domainList = await getWebviewAccessDomain(currentMiniProgramAppId || '');

  if (Array.isArray(domainList)) {
    return !domainList.some(
      (domain: string) => url.startsWith(domain),
    );
  }

  return true;
};

/**
 * 是否是臻有钱-微信小程序，区分哈啰出行-微信小程序
 * 臻有钱小程序：true
 * 哈啰出行小程序、其他小程序：false
 */
export function isFinanceWechatMini(): boolean {
  /** 若在小程序环境，无appid参数时，默认是臻有钱小程序 */
  return platform.isWechatMini && (
    !currentMiniProgramAppId || currentMiniProgramAppId === FINANCE_WX_MINI_PROGRAM.appId);
}

/**
 * 是否 非臻有钱微信小程序的 微信小程序h5环境
 * 哈啰出行小程序、其他小程序：true
 * 臻有钱小程序：false
 */
export function isHelloWechatMini(): boolean {
  return platform.isWechatMini && currentMiniProgramAppId !== FINANCE_WX_MINI_PROGRAM.appId;
}

/**
 * 微信小程序环境，返回上一页
 * 若是臻有钱小程序，则调用 wechat.navigateBack()
 * 若是哈啰出行小程序，则调用 window.history.go(-1)
 */
export function miniProgramBackPreviousPage(): void {
  if (isHelloWechatMini()) {
    window.history.go(-1);
  } else {
    wechat.navigateBack();
  }
}

/**
 * 缓存宿主环境小程序 appId
 * 后续跳转 AppFinanceLoanH5... 时，无需通过 URL 传递 appId
 */
function initEnvMiniProgramAppId(): void {
  try {
    const { appId } = URLUtils.getQueryMap();

    if (appId) {
      currentMiniProgramAppId = appId as string;

      sessionStorage.setItem(MINI_PROGRAM_APPID_SESSION_KEY, currentMiniProgramAppId);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

initEnvMiniProgramAppId();

export default wechat;
